import { useState } from "react";
import Modal from "../components/Modal";
import Field, { inputStyle, selectStyle } from "../components/Field";
import { NPS_CATEGORIES } from "../constants";
import { generateId, getToday } from "../utils";

export default function NewSatisfaction({ open, onClose, setSatisfaction, clients, userId }) {
  const [form, setForm] = useState({
    clientId: "", score: 8, category: "geral", feedback: "", surveyDate: getToday(),
  });

  const wonClients = (clients || []).filter((c) => c.stage === "ganho");
  const selectedClient = wonClients.find((c) => c.id === form.clientId);

  const handleSave = () => {
    if (!form.clientId) return;
    const entry = {
      id: generateId(), userId,
      clientId: form.clientId,
      clientName: selectedClient?.company || "",
      score: parseInt(form.score),
      category: form.category,
      feedback: form.feedback,
      surveyDate: form.surveyDate,
      createdAt: getToday(),
    };
    setSatisfaction((prev) => [...prev, entry]);
    setForm({ clientId: "", score: 8, category: "geral", feedback: "", surveyDate: getToday() });
    onClose();
  };

  if (!open) return null;

  const scoreColor = form.score >= 9 ? "#059669" : form.score >= 7 ? "#f59e0b" : "#ef4444";
  const scoreLabel = form.score >= 9 ? "Promotor" : form.score >= 7 ? "Neutro" : "Detrator";

  return (
    <Modal open={open} onClose={onClose} title="Nova Pesquisa de Satisfação" w={460}>
      <Field label="Cliente (Ativo)" required>
        <select style={selectStyle} value={form.clientId} onChange={(e) => setForm((p) => ({ ...p, clientId: e.target.value }))}>
          <option value="">Selecione um cliente...</option>
          {wonClients.map((c) => (
            <option key={c.id} value={c.id}>{c.company}</option>
          ))}
        </select>
      </Field>

      <Field label="Categoria">
        <select style={selectStyle} value={form.category} onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))}>
          {NPS_CATEGORIES.map((c) => (
            <option key={c.id} value={c.id}>{c.label}</option>
          ))}
        </select>
      </Field>

      <Field label="Data da Pesquisa">
        <input style={inputStyle} type="date" value={form.surveyDate} onChange={(e) => setForm((p) => ({ ...p, surveyDate: e.target.value }))} />
      </Field>

      <Field label={`Nota NPS (0-10) — ${scoreLabel}`}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <input
            type="range" min="0" max="10" value={form.score}
            onChange={(e) => setForm((p) => ({ ...p, score: parseInt(e.target.value) }))}
            style={{ flex: 1 }}
          />
          <div style={{
            width: 44, height: 44, borderRadius: 10,
            background: scoreColor + "15",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 20, fontWeight: 800, color: scoreColor,
          }}>
            {form.score}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 9, color: "#94a3b8", marginTop: 4 }}>
          <span>0 — Nada provável</span>
          <span>10 — Muito provável</span>
        </div>
      </Field>

      <Field label="Feedback / Comentário">
        <textarea
          style={{ ...inputStyle, minHeight: 70, resize: "vertical" }}
          value={form.feedback}
          onChange={(e) => setForm((p) => ({ ...p, feedback: e.target.value }))}
          placeholder="O que o cliente comentou? Sugestões, reclamações, elogios..."
        />
      </Field>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 12 }}>
        <button onClick={onClose} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          Cancelar
        </button>
        <button
          onClick={handleSave}
          disabled={!form.clientId}
          style={{
            padding: "8px 16px", borderRadius: 8, border: "none",
            background: !form.clientId ? "#94a3b8" : "#251C59",
            color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
          }}
        >
          Registrar Pesquisa
        </button>
      </div>
    </Modal>
  );
}
